import React from "react";
import { useStore } from "../../context/StoreContext";
import { Select } from "antd";
import { useAuth } from "../../context/AuthContext";

const StoreContextSelector = () => {
  const { user, hasPermission } = useAuth();
  const { stores, selectedStore, changeStore } = useStore();

  return (
    <>
      {user?.role === "ADMIN" || user?.role === "MANAGER" ? (
        <Select
          value={selectedStore?.id}
          onChange={changeStore}
          onClear={() => changeStore(undefined)}
          placeholder="Select a store"
          // allowClear
        >
          {/* <Select.Option>Select Store</Select.Option> */}
          <Select.Option value="">All Stores</Select.Option>
          {stores.map((store) => (
            <Select.Option value={store.id}>{store.name}</Select.Option>
          ))}
        </Select>
      ) : (
        <div>{selectedStore?.name}</div>
      )}
    </>
  );
};

export default StoreContextSelector;
